(function (app) {
    app.provider("arcProductApi", [function () {
        this.$get = ["complianceHubApiGateway", function (complianceHubApiGateway) {
            var service = {};

            service.create = function(productId, product) {
                return complianceHubApiGateway.put("/ArcProducts/" + productId, product);
            };

            return service;
        }];
    }]);

    app.provider("arcBusinessApi", [function () {
        this.$get = ["complianceHubApiGateway", function (complianceHubApiGateway) {
            var service = {};

            service.create = function (businessId, business) {
                return complianceHubApiGateway.put("/ArcBusinesses/" + businessId, business);
            };

            return service;
        }];
    }]);

    app.provider("arcLineOfBusinessApi", [function () {
        this.$get = ["complianceHubApiGateway", function (complianceHubApiGateway) {
            var service = {};

            service.create = function (arcLineOfBusinessId, arcLineOfBusiness) {
                return complianceHubApiGateway.put("/ArcLinesOfBusiness/" + arcLineOfBusinessId, arcLineOfBusiness);
            };

            return service;
        }];
    }]);

    app.provider("arcLineOfBusinessCategoryApi", [function () {
        this.$get = ["complianceHubApiGateway", function (complianceHubApiGateway) {
            var service = {};

            service.create = function (arcLineOfBusinessCategoryId, arcLineOfBusinessCategory) {
                return complianceHubApiGateway.put("/ArcLineOfBusinessCategories/" + arcLineOfBusinessCategoryId, arcLineOfBusinessCategory);
            };

            return service;
        }];
    }]);
})(window.app);